import React from 'react';
import PropTypes from 'prop-types';
import ScheduleTableTitle from './ScheduleTableTitle';
import ScheduleTableCell from './ScheduleTableCell';
import SvgIcon from './SvgIcon';


const ScheduleTable = (props) => {
    const lastSportItem = { ...props.sports['Церемонии'] };
    const sportsItems = props.sports;
    delete sportsItems['Церемонии'];
    sportsItems['Церемонии'] = lastSportItem;

    return (
        <section className="schedule-table">
            <div className="schedule-table__title">
                <ScheduleTableTitle days={props.days} />
            </div>
            <div className="schedule-table__body">
                {Object.keys(sportsItems).map((sportName, index) => (
                    <div className="schedule-table__row" data={`row_${index}`} key={sportName}>
                        <div className="schedule-table__row-name">
                            <SvgIcon typeID={sportName} />
                            <span>{sportName}</span>
                        </div>
                        <div className="schedule-table__row-list">
                            {props.days.map((day) => {
                                const date = day.date < 10 ? `0${day.date}` : `${day.date}`;
                                const eventsList = props.sports[sportName][date] ?
                                    props.sports[sportName][date].events : null;
                                const showCard = typeof props.sports[sportName][date] !== 'undefined' ?
                                    props.sports[sportName][date].showCard :
                                    null;

                                return (<ScheduleTableCell
                                    sportName={sportName}
                                    date={date}
                                    showCard={showCard}
                                    dayEvents={eventsList}
                                    allEvents={props.events}
                                    key={date}
                                    toggleEventCard={props.toggleEventCard}
                                />);
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

ScheduleTable.propTypes = {
    days: PropTypes.arrayOf(PropTypes.shape({
        weekDay: PropTypes.shape({
            short: PropTypes.string
        }),
        date: PropTypes.number
    })).isRequired,
    // eslint-disable-next-line
    events: PropTypes.object,
    // eslint-disable-next-line
    sports: PropTypes.object
};

export default ScheduleTable;



// WEBPACK FOOTER //
// ./src/components/ScheduleTable.jsx